var map = {
	"./Photo10.jpg": 772,
	"./Photo11.jpg": 554,
	"./Photo12.jpg": 805,
	"./Photo13.jpg": 936,
	"./Photo2.jpg": 488,
	"./Photo3.jpg": 749,
	"./Photo4.jpg": 862,
	"./Photo5.jpg": 323,
	"./Photo6.jpg": 628,
	"./Photo7.jpg": 1,
	"./Photo8.jpg": 378,
	"./Photo9.jpg": 375,
	"./mohit kumar yoga.jpg": 231,
	"./photo1.jpg": 111,
	"./yoga-background.jpg": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;